import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>COMING SOON ...</h1>
      <h2>Something great is on the way.</h2>
    </div>
  );
}

export default App;
